/** Preserve the existing sort/relevance order within each availability group. */
export function incomingUnitsLast<T extends { status: string }>(units: readonly T[]): T[] {
  return [
    ...units.filter((unit) => unit.status !== "coming_soon"),
    ...units.filter((unit) => unit.status === "coming_soon"),
  ];
}

/** Global ranges ensure incoming units start after every in-stock match. */
export function inventoryPageRanges(offset: number, size: number, inStockCount: number) {
  const stockSize = Math.max(0, Math.min(size, inStockCount - offset));
  const incomingOffset = Math.max(0, offset - inStockCount);
  return {
    stock: stockSize ? { from: offset, to: offset + stockSize - 1 } : null,
    incoming: stockSize < size ? { from: incomingOffset, to: incomingOffset + size - stockSize - 1 } : null,
  };
}